module.exports = __webpack_public_path__ + "public/files/img/6.dab3bdbe.png";